export default function AddPhotoIcon({ className }: { className?: string }) {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.5 35V5H23.8333V8.33333H8.83333V31.6667H32.1667V16.6667H35.5V35H5.5ZM28.8333 15V11.6667H25.5V8.33333H28.8333V5H32.1667V8.33333H35.5V11.6667H32.1667V15H28.8333ZM10.5 28.3333H30.5L24.25 20L19.25 26.6667L15.5 21.6667L10.5 28.3333ZM8.83333 18.3333V31.6667V8.33333V18.3333Z"
        fill="#7F7F7F"
      />
    </svg>
  );
}
